import { MuWidget } from "mu-widget/lib/MuWidget";
import {t} from "../../translate";
import {UiFlashItem} from "mu-widget/lib/components/UiFlash";
import {frontRouter} from "../../FrontRouter";

export class UiAppClientDataBanner extends MuWidget
{
    // @ts-ignore
    public flashMessage : UiFlashItem;

    beforeIndex() {
        this.muAppendContent(`
            <p>${t('clientDataBannerInfo')}</p>
            <div class="buttons">
                <span mu="bOpenClientData" class="btn--primary">${t('clientDataBannerYesEntry')}</span>
                <span mu="bClose" class="btn--secondary">${t('genLater')}</span>
            </div>
        `);
    }

    bOpenClientData_click() {
        frontRouter.navPushSet('clientData');
        this.flashMessage.close_click();
    }

    bClose_click() {
        this.flashMessage.close_click();
    }

}